import React, { type ChangeEvent, useState }  from 'react';
import { useForm } from 'react-hook-form';
import Upload, { type UploadProps } from 'rc-upload';

const new_support_service_ticket__c = Math.floor(new Date().getTime() / 1000);
const password = () => {
  const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
  let _password = '';
  for (let i = 0; i < 8; i++) {
    const randomIndex = Math.floor(Math.random() * chars.length);
    _password += chars.charAt(randomIndex);
  }
  return _password;
}

const UploadLogs = () => {
  const { register, handleSubmit, formState: { isSubmitting, errors }, setValue, setError, clearErrors } = useForm();
  //default state
  const [upload_system , setUploadSystem] = useState<string>('s3');
  const [fileList, setFileList] = useState<Array<string>>([]);
  const [fileSasUlrs, setFileSasUlrs] = useState<Array<string>>([]);
  const [maxFiles, setMaxFiles] = useState<number>(0);
  const [uploading, setUploading] = useState(false);
  const [showTYmessage, setShowTYmessage] = useState(false);
  const [tyMessage , setTyMessage] = useState<string>('<p>要求が送信されました。</p><p>ありがとうございます。<br>AvePoint サポート チーム</p>');

  const showUpload = (e: ChangeEvent<HTMLInputElement>) => {
    const uploadType = e.target.value;
    // Clear or set error based on the selected upload type
    if (uploadType === "ftp") {
      clearErrors("file");
    } else {
      setError("file", {
        type: "manual",
        message: "ファイルのアップロードをお願いします!" // Update this message as needed
      });
    }
    setUploadSystem(uploadType);
  };
  
  // Generic form data builder function
  const buildFormData = (folder: string, file?: File, fileName?: string) => {
    const formData = new FormData();
    formData.append('folder', folder);
    if (file) formData.append('file', file);
    if (fileName) formData.append('fileName', fileName);
    return formData;
  };

  // Generic fetch request function
  const fetchRequest = async (url: string, formData: FormData, onSuccess: Function, onError: Function) => {
    try {
      const response = await fetch(url, {
        method: 'POST',
        body: formData,
      });
      if (response.ok) {
        onSuccess(response);
      } else {
        const errorMessage = await response.text();
        onError(new Error(errorMessage));
      }
    } catch (error) {
      onError(error);
    }
  };

  const customRequest = ({ action, file, onProgress, onSuccess, onError }: any) => {
    const formData = buildFormData(new_support_service_ticket__c as unknown as string, file);
    if (onProgress) {
      onProgress({ percent: 50 });
    }
    fetchRequest(action, formData,
      async (response: Response) => {
        if (onProgress) onProgress({ percent: 100 });
        const data = await response.json();
        onSuccess(data, file);
      },
      onError
    );
    return {
      abort() {
        throw new Error('Upload aborted');
      },
    };
  };

  // Delete file function
  const deleteFile = async (fileName: any) => {
    const formData = buildFormData(new_support_service_ticket__c as unknown as string, undefined, fileName);
    await fetchRequest('/api/files/delete', formData, 
      () => {
        let newMaxFiles = maxFiles - 1;
        setFileList((prevFileList) => prevFileList.filter(file => file !== fileName));
        setFileSasUlrs((prevUrl) => prevUrl.filter(url => !new RegExp(fileName, "i").test(decodeURIComponent(url))));
        setMaxFiles(Math.max(0, newMaxFiles));
        if(newMaxFiles <= 0){
          setError("file", {
            type: "manual",
            message: "ファイルのアップロードをお願いします!"
          });
        }
        // update form values
        setValue('sasUrls', fileSasUlrs.filter(url => !new RegExp(fileName, "i").test(decodeURIComponent(url))));
      },
      (error: Error) => {
        throw new Error(`Error deleting file: ${error.message}`);
      }
    );
  };

  // Upload configuration item
  const uploadProps: UploadProps = {
    action: '/api/files/upload',
    type: 'drag',
    multiple: false,  // Single file upload
    onStart() {
      setUploading(true);
    },
    onProgress({ percent }) {
      //console.log('onProgress', `${percent}%`);
    },
    onSuccess(data: any, file: any) {
      let newMaxFiles = maxFiles + 1;
      setUploading(false);
      setFileList((prevList) => [...prevList, file.name]);
      setFileSasUlrs((prevUrl) => [...prevUrl, data.sasUrl]);
      setMaxFiles(newMaxFiles);
      // remove error message
      clearErrors("file");
      // update form values
      setValue('file', file.name);
      setValue('sasUrls', [...fileSasUlrs, data.sasUrl]);
    },
    onError(error: any) {
      setError("file", {
        type: "manual",
        message: "ファイルのアップロードをお願いします!"
      });
      setUploading(false);
    },
    beforeUpload(file: any) {
      const acceptFileTypes = /\.(gif|jpe?g|png|docx?|pdf|xlsx?|txt|log|zip(\.\d+)?|7z(\.\d+)?|rar(\.\d+)?|pptx?)$/i;
      const maxFileSize = 100 * 1024 * 1024; // 100MB
      return new Promise<void>((resolve, reject) => {
        // Check file type and size
        const isValidFile = acceptFileTypes.test(file.name) && file.size <= maxFileSize;
        setTimeout(() => {
          if (isValidFile) {
            clearErrors("file"); // Clear errors if the file is valid
            resolve();
          } else {
            // Set error before rejecting
            setError("file", {
              type: "manual",
              message: "ファイルタイプとファイルサイズのチェックをお願いします!"
            });
            reject();
          }
        }, 1000);
      });
    },
    customRequest: customRequest,
    style: { display: 'inline-block', width: 200, height: 200, background: '#eee' }
  };

  const handleFormSubmit = async (data: Record<string, any>) => {
    if(data.upload_system == "s3" && maxFiles == 0) {
      setError("file", {
        type: "manual",
        message: "ファイルのアップロードをお願いします!" // Update this message as needed
      });
      return false;
    }
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      const raw = JSON.stringify(data);
      const requestOptions: RequestInit = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow" as RequestRedirect
      };
      // Make the API request
      const response = await fetch("https://www.avepoint.com/api/v1/upload-log-send-email", requestOptions);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const emailResult = await response.json();
      if (response.ok && emailResult.status_code === 201) {
        setShowTYmessage(true);
      } else {
        setShowTYmessage(true);
        setTyMessage("<p>フォームの送信に失敗しました。詳細を確認してもう一度お試しください。</p>");
      }
    } catch (error) {
      setShowTYmessage(true);
      setTyMessage("<p>申し訳ございません。問題が発生しました。メールの送信中に予期しないエラーが発生しました。</p>");
    }
  }; 

  return (
    <div className='container mx-auto px-10 bg-white'>
      {!showTYmessage ? <form onSubmit={handleSubmit(handleFormSubmit)}>
        <div className='mx-auto mb-10'>
          <div className="space-y-4">
            <h2>お客様情報</h2>
            <p>(<span className="text-primary">*</span>) が付いているフィールドは必須入力項目です.</p>
          </div>
          <div>
            <div className='mt-8'>
              <p className='block text-gray-700 text-sm font-bold mb-2'><span className="text-primary">*</span><label htmlFor="firstname">名:</label></p>
              <input className='px-3 py-2 bg-white border-gray-200 focus:border-gray-300 focus:outline-none w-full rounded-md sm:text-sm' type="text" {...register('firstname', { required: '必須フィールド' })}/>
              {errors.firstname?.message && <p className="text-primary">{errors.firstname.message as string}</p>}
            </div>
            <div className='mt-8'>
              <p className='block text-gray-700 text-sm font-bold mb-2'><span className="text-primary">*</span><label htmlFor="lastname">姓:</label></p>
              <input className='px-3 py-2 bg-white border-gray-200 focus:border-gray-300 focus:outline-none w-full rounded-md sm:text-sm' type="text" {...register('lastname', { required: '必須フィールド' })}/>
              {errors.lastname?.message && <p className="text-primary">{errors.lastname.message as string}</p>}
            </div>
            <div className='mt-8'>
              <p className='block text-gray-700 text-sm font-bold mb-2'><span className="text-primary">*</span><label htmlFor="email">メール:</label></p>
              <input className='px-3 py-2 bg-white border-gray-200 focus:border-gray-300 focus:outline-none w-full rounded-md sm:text-sm' type="text" {...register('email', {validate: (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)})}/>
              {errors.email && <p className="text-primary">必須フィールド</p>}
            </div>
            <div className='mt-8'>
              <p className='block text-gray-700 text-sm font-bold mb-2'><span className="text-primary">*</span><label htmlFor="company">会社名:</label></p>
              <input className='px-3 py-2 bg-white border-gray-200 focus:border-gray-300 focus:outline-none w-full rounded-md sm:text-sm' type="text" {...register('company', { required: '必須フィールド' })}/>
              {errors.company?.message && <p className="text-primary">{errors.company.message as string}</p>}
            </div>
            <div className='mt-8'>
              <p className='block text-gray-700 text-sm font-bold mb-2'><span className="text-primary">*</span><label htmlFor="phone">電話:</label></p>
              <input className='px-3 py-2 bg-white border-gray-200 focus:border-gray-300 focus:outline-none w-full rounded-md sm:text-sm' type="text" {...register('phone', { required: '必須フィールド' })}/>
              {errors.phone?.message && <p className="text-primary">{errors.phone.message as string}</p>}
            </div>
            <div className='mt-8'>
              <p className='block text-gray-700 text-sm font-bold mb-2'>お問い合わせ番号:</p>
              <input className='px-3 py-2 bg-white border-gray-200 focus:border-gray-300 focus:outline-none w-full rounded-md sm:text-sm' type="text" {...register('case_num')}/>
            </div>
          </div>
        </div>
        <div className='mt-8'>
          <div>
            <input type="hidden" value={new_support_service_ticket__c} {...register('new_support_service_ticket__c')}/>
            <input type="hidden" value={password()} {...register('ftp_password')}/>
            <div className='mt-8'>
              <p className='block text-gray-700 text-sm font-bold mb-2'>転送方法:</p>
              <input type="radio" className="border-gray-200 appearance-none focus:ring-0 focus:ring-white checked:bg-white checked:text-black checked:border-green checked:bg-[url('https://assets.avepoint.com/upload/icons/form-circle.svg')] checked:bg-[length:9px_9px] rounded-full w-5 h-5" {...register('upload_system', { value: "s3" })} value="s3" onChange={e => showUpload(e)}/><span className="ml-2 mr-5 text-gray-700">HTTP</span>
              <input type="radio" className="border-gray-200 appearance-none focus:ring-0 focus:ring-white checked:bg-white checked:text-black checked:border-green checked:bg-[url('https://assets.avepoint.com/upload/icons/form-circle.svg')] checked:bg-[length:9px_9px] rounded-full w-5 h-5"{...register('upload_system')} value="ftp" onChange={e => showUpload(e)}/><span className="ml-2 text-gray-700">FTP</span>
            </div>
            <div className={`mx-auto mt-5 ${upload_system == "s3" ? "" : "none"}`}>
              <p className='mb-2'>50 MB 以内のファイルの場合、HTTP プロトコルを使用することができます。</p>
              <p className='mb-2'>このオプションを選択すると、添付ファイルをアップロードしてサポート チームに直接に送信します。</p>
              <p><span className="text-primary">*</span>添付ファイル:</p>
              {/* Upload */}
              <div className='[&_span]:!w-full [&_span]:!h-auto [&_span]:p-8 [&_span]:my-4 [&_span]:rounded-md'>
                <div>
                  {maxFiles < 5 && <>
                    <Upload {...uploadProps}>
                    <p className='text-center'>Drag Files Here</p>
                    <p className='text-center my-3'>or</p>
                    <button type="button" className="block py-2 px-4 border-gray-200 mx-auto bg-white rounded-md">Choose Files</button>
                    </Upload>
                    {uploading && <p><img className="mx-auto" src="https://assets.avepoint.com/upload/images/icons/loading.gif" alt="uploading" width={40} height={40} loading="eager"/></p>}
                  {errors.file && <p className="text-primary">{errors.file.message ? errors.file.message as string : "ファイルのアップロードをお願いします!"}</p>}</>}
                  {!!fileList && <ul className='space-y-3'>
                    {fileList.map((file, index) => (
                      <li className="flex flex-row items-center" key={file + index}>{file}  <button className="ml-6" type="button" onClick={() => deleteFile(file)}><img className="logo" src="https://assets.avepoint.com/upload/images/icons/icons8-close.svg" alt="close" width={20} height={20} loading="eager"/></button></li>
                    ))}
                  </ul>}
                </div>
              </div>
              <p className='pt-4'>ログ / スクリーンショットを 50 MB 以下のファイル 1 件に圧縮してください。</p>
            </div>
            <div className={`mx-auto mt-5 ${upload_system == "ftp" ? "" : "none"}`}>
              <p className='mb-2'>50 MB 以上のファイルの場合、FTP プロトコルの使用が推奨されます。</p>
              <p>このオプションを選択すると、FTP 資格情報を担当者様のメールアドレスに直接に送信します。これらの資格情報を使用し、添付ファイルをセキュア FTP サーバーにアップロードしてください。</p>
            </div>
          </div>
        </div>
        <div className='mt-8'>
          <p className='block text-gray-700 text-sm font-bold mb-2'>メッセージを入力します:</p>
          <textarea className='w-full px-3 py-2 border rounded-md border-gray-200 focus:border-gray-300 focus:outline-none placeholder-gray-400 text-base' {...register('comments')}></textarea>
        </div>
        <div className='mx-auto mt-10'>
          <button className={`survey-button text-white rounded-full h-[50px] w-44 text-center bg-primary font-semibold`} disabled={isSubmitting} type="submit">{isSubmitting ? "送信中..." : "送信"}</button>
        </div>
      </form>
      : <div className='pt-20' dangerouslySetInnerHTML={{ __html:tyMessage }}></div>}
    </div>
  );
};

export default UploadLogs;